import React from 'react'

import Item from './styles/item-basic-info'

const ItemAdvancedInfo = ({ children }) => {
  return <Item>{children}</Item>
}

export default ItemAdvancedInfo
